const data = {
	"width": 20,
	"height": 20,
	"body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M17.707 9.293a1 1 0 0 1 0 1.414l-7 7a1 1 0 0 1-1.414 0l-7-7A.997.997 0 0 1 2 10V5a3 3 0 0 1 3-3h5c.256 0 .512.098.707.293l7 7ZM5 6a1 1 0 1 0 0-2a1 1 0 0 0 0 2Z\" clip-rule=\"evenodd\"/>"
};
export default data;
